import React from 'react';
import { getCompanyNameRoute, getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { CustomerAddressWidgetItem } from '../../widget';
import { Maybe } from '@css-xp/ppc-graphtypes';
import { CustomerAddressQueryItem } from './customer-address-query-wrapper';

type SoldToAddressWidgetArr = Maybe<Array<CustomerAddressQueryItem>> | undefined;

export const getCustomerAddressWidgetContent = (
  soldToAddresses: SoldToAddressWidgetArr,
  heading?: string,
  version?: number
) => {
  if (!soldToAddresses || !soldToAddresses.length) {
    return null;
  }

  return soldToAddresses.map((soldToAddress, index) => {
    if (!soldToAddress || !(soldToAddress.id || soldToAddress.name)) {
      return null;
    }
    // if id is not there, name will definitely be there based on above check
    const URL = soldToAddress.id
      ? getRouteUrl(routePaths.customerAddressDetailsById, {
          txaId: soldToAddress.transactionAccountId,
          addressId: soldToAddress.id,
        })
      : getCompanyNameRoute({ companyName: soldToAddress.name as string, txaId: soldToAddress.transactionAccountId });

    return <CustomerAddressWidgetItem url={URL} key={index} {...soldToAddress} heading={heading} version={version} />;
  });
};
